<template name="addCopy">
  <div class="addCopy">
    <div class="people-list">
      <div>
        <div class="row" v-for="(user, idx) in copyList" :key="idx">
          <div class="col-10">
            <img class="head-portrait" :id="user.id" :src="user.avatar">
            <span>{{ user.userName }}({{ user.deptName }})</span>
          </div>
          <div class="col-2">
            <img class="delete-people" src="../assets/images/2-copy-12@2x.png"
            @click="deleteKO(user.id)">
          </div>
        </div>
      </div>
    </div>
    <div class="addBtn new-invite-title" @click="changeKO">
      <i class="iconfont icon-add"></i><span>{{$t('AddCC')}}</span>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'addCopy',
  props: {
    copyList: Array,
  },
  data() {
    return {
    };
  },
  methods: {
    changeKO() {
      this.$emit('koStatus', { type: 'copy' });
    },
    deleteKO(id) {
      this.$emit('deleteKO', { type: 'copy', id });
    },
  },
};
</script>

<style scoped lang="scss">
  .addCopy {
    width: 100%;
    margin: auto;
    width: 100%;
    margin: 0 auto;
    padding: 0;
    background-color: #fff;
    border-radius: 4px;
    .addBtn {
      padding: 12px;
      img {
        width: 21px;
        height: 22px;
        margin-right: 6px;
      }
    }
    .people-list {
      border-bottom: 1px solid #f0f1f2;
      & > div {
        padding: 0 12px;
        .row {
          margin: 0;
          padding-top: 5px;
          padding-bottom: 5px;
          align-items: center;
          border-bottom: 1px solid #f0f1f2;
          div {
            padding: 0;
            // font-family: HiraginoSansGB-W3;
            font-size: 13px;
            color: #4a4a4a;
            img.head-portrait {
              width: 40px;
              height: 40px;
              margin-right: 10px;
              border-radius: 50%;
            }
            .delete-people {
              width: 20px;
              height: 20px;
            }
          }
          & > div:nth-of-type(2) {
            text-align: right;
            padding-right: 10px;
          }
        }
      }
    }
  }
</style>
